<template>
	<div>
		<Header></Header>
		<Search :seachcon='keyword' :catid='id'></Search>
		<div class="content">
			<div class="w">
				<!-- 面包屑 -->
				<div class="nav d-flex align-items-center">
					<div class="nav-item d-flex align-items-center" @click="qyback()">
						<span>首页</span>
					</div>
					<img class="nav-img" src="../../../assets/images/goods_right.png" alt v-if='catlist1' />
					<div class="nav-items d-flex align-items-center">
						<dl class="nav-items" v-if='catlist1.length'>
							<dt class="d-flex align-items-center">
								<!-- <div v-for="(item,index) in catlist" :key="index"> {{item.name}}</div> -->
								<div v-for="(item,index) in catlist1" :key="index" v-if="item. is_sel==1">{{item.name}}</div>
								<img class="img-default nav-xia" src="../../../assets/images/top_xia.svg" alt />
							</dt>
							<dd class="d-flex flex-wrap">
								<div v-for="(item,index) in catlist1" :key="index" @click="sort(item.id)"  >
									<div>
										{{item.name}}
									</div>
								</div>
							</dd>
						</dl>
					</div>
					<img class="nav-img" src="../../../assets/images/goods_right.png" alt v-if='catlist2' />
					<div class="nav-items d-flex align-items-center">
						<dl class="nav-items" v-if='catlist2'>
							<dt class="d-flex align-items-center">
								<!-- <div v-for="(item,index) in catlist" :key="index"> {{item.name}}</div> -->
								<div v-for="(item,index) in catlist2" :key="index" v-if="item. is_sel==1">{{item.name}}</div>
								<img class="img-default nav-xia" src="../../../assets/images/top_xia.svg" alt />
							</dt>
							<dd class="d-flex flex-wrap">
								<div v-for="(item,index) in catlist2" :key="index" @click="sort(item.id)"  >
									<div>{{item.name}}</div>
								</div>
							</dd>
						</dl>
					</div>
					<img class="nav-img" src="../../../assets/images/goods_right.png" alt v-if='catlist3' />
					<div class="nav-items d-flex align-items-center">
						<dl class="nav-items" v-if='catlist3'>
							<dt class="d-flex align-items-center">
								<!-- <div v-for="(item,index) in catlist" :key="index"> {{item.name}}</div> -->
								<div v-for="(item,index) in catlist3" :key="index" v-if="item. is_sel==1">{{item.name}}</div>
								<img class="img-default nav-xia" src="../../../assets/images/top_xia.svg" alt />
							</dt>
							<dd class="d-flex flex-wrap">
								<div v-for="(item,index) in catlist3" :key="index" @click="sort(item.id)"  >
									<div>
										{{item.name}}
									</div>
								</div>
							</dd>
						</dl>
					</div>
					

					<!-- <img class="nav-img" src="../../../assets/images/goods_right.png" alt  /> -->
					<!-- <div class="nav-option d-flex align-items-center" v-for="(item,index) in ttshop_brand" :key="index" v-if="item.id == brand_id">
						品牌：
						<span>{{item.name}}</span>
						<img class="nav-del" src="../../assets/images/nav_del.png" alt @click="closeid()" />
					</div> -->
				</div>
				<!-- 商品列表 -->
				<div class="goods-box d-flex justify-content-between">
					<div class="goods-rs">
						<!-- 筛选 -->
						<div class="filtrate d-flex justify-content-between">
							<div class="filtrate-l d-flex">
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(0)" :class="{filtrate_active:0 == filtrateIndex}">综合</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(1)" :class="{filtrate_active:1 == filtrateIndex}">新品</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(2)" :class="{filtrate_active:2 == filtrateIndex}">
									单价
									<div class="filtrate-l-img">
										<img src="../../../assets/images/filtrate_pic.svg" alt v-if="filtrateIndex != 2" />
										<div v-else>
											<img src="../../../assets/images/filtrate_picnext.png" alt v-if="sort_type == 0" />
											<img src="../../../assets/images/filtrate_picperv.png" alt v-if="sort_type == 1" />
										</div>
									</div>
								</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(3)" :class="{filtrate_active:3 == filtrateIndex}">销量</div>
								<div class="filtrate-pic">
									<div class="d-flex align-items-center filtrate-pics">
										<div class="filtrate-pic-input d-flex align-items-center">
											<!-- ￥ -->
											<input type="number" placeholder="区间" v-model="smallnum" ref="smallnum" />
										</div>
										<div class="line"></div>
										<div class="filtrate-pic-input d-flex align-items-center">
											<!-- ￥ -->
											<input type="number" placeholder="区间" v-model="bignum" ref="bignum" />
										</div>
									</div>
									<div class="clearfloat filtrate-picbut">
										<span @click="confirms()">确定</span>
										<span @click="closenum()">清空</span>
									</div>
								</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center">
									<el-radio label="1" v-model="isRec"  @change="changetype(1)">好物推荐</el-radio>
									<el-radio label="2" v-model="isRec"  @change="changetype(2)">爆款</el-radio>
								</div>
							</div>
							<div class="filtrate-r d-flex align-items-center">
								<template v-if="false">
									<div class="filtrate-r-item d-flex align-items-center">
										<div class="filtrate-r-img">
											<img src="../../../assets/images/select_unchecked.png" alt />
										</div>自营商品
									</div>
									<div class="filtrate-r-item d-flex align-items-center">
										<div class="filtrate-r-img">
											<img src="../../../assets/images/select_unchecked.png" alt />
										</div>有货商品
									</div>
								</template>
								<div class="filtrate-r-all">共 {{ttshop_znum}}个商品</div>
								<div class="filtrate-r-page d-flex align-items-center" v-if="ttshop_listshop.length">
									<div class="page-img" :style="{'cursor': currentPage1<=1 ? 'no-drop' : 'pointer'}" @click="page_prevs">
										<img src="../../../assets/images/goods_left.png" alt />
									</div>
									<div class="page-num">
										<span>{{currentPage1 * list_count > ttshop_znum ? ttshop_znum : currentPage1 * list_count}}</span> /{{ttshop_znum}}
									</div>
									<div class="page-img" :style="{'cursor': currentPage1>=class_list_num ? 'no-drop' : 'pointer'}" @click="page_nexts">
										<img src="../../../assets/images/goods_right.png" alt />
									</div>
								</div>
							</div>
						</div>
						<!-- 商品 -->
						<div v-if="ttshop_listshop && ttshop_listshop.length">
							<div class="list">
								<div class="item" v-for="(item,index) in ttshop_listshop" :key="index" @click="listrouter(item.id)">
									<img class="item-img" v-lazy="item.pic_url" alt :onerror="errorImg" />
									<img class="img-default-img" v-if="item.is_hot=='1'" src="../../../assets/purchase/image/index/baokuan.png" alt="">
									<div class="pic1" style="margin: 10px 0 0 10px;">
										<span style="font-weight: 500;text-decoration: line-through;font-size: 12px;color: #333333;">京东￥{{item.jd_price}}</span>
									</div>
									<div class="pic">
										<span style="margin-right: 5px;font-weight: 500;color: #CC0000;font-size: 14px;">单价</span>￥
										<span style="font-weight: 800;color: #CC0000;font-size: 20px;">{{Math.trunc(item.price)}}.</span><span style="font-weight: 500;color: #CC0000;font-size: 14px;">{{item.price.split('.')[1]}}</span>
									</div>
									<div class="name">{{item.name}}</div>
									<div class="label">
										<span v-for="(itemed,index) in item.service" :key="index">{{itemed}}</span>
									</div>
								</div>
							</div>
							<div class="goods-paging d-flex align-items-center justify-content-center">
								<!-- <el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="list_count" -->
								 <!-- :hide-on-single-page='value' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination> -->
								<el-pagination class="ttshop_pages" background @current-change="handleCurrentChangeList" :current-page.sync="currentPage1" 
								 layout="prev, pager, next" :hide-on-single-page="true" :page-size="list_count" :total="ttshop_znum"></el-pagination>
							</div>
						</div>
						<!-- 暂无商品时暂时 -->
						<template v-else>
							<div class="zanwugoods" v-if="datatype">
								<img src="../../../assets/images/ttshop_zanwu.png" alt="">
								<p>暂无商品</p>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Search from "@/components/purchase/search/search";
	import Footer from "@/components/purchase/footer/footer";
	
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Search,
			Header,
			Footer,
		},
		data() {
			return {
				catlist: '', //面包屑分类
				catlist1: '', //面包屑分类
				catlist2: '', //面包屑分类
				catlist3: '', //面包屑分类
				route_url: this.$store.state.route_url,
				brandIndex: false,
				more: true,
				iShow: -1,
				value: true,
				isHidden: false,
				filtrateIndex: 0,
				sort_type: '', //价格上下
				currentPage1: 1, //页数
				ttshop_znum: 0,  //总商品数量
				datatype: false,
				id: this.$route.query.id, //商品id
				ttshop_listshop: '', //商品列表
				smallnum: '', //最小值
				bignum: '', ///最大值
				start_price: '', //传最小值
				end_price: '', //传最大值
				list_page: 1,   //商品分页
				list_count: 20,  //商品分页
				list_list_num: 0,
				isRec:"",
				keyword: this.$route.query.keyword, // 搜索文字
				errorImg: 'this.src="' + require('../../../assets/images/lodingsb.svg') + '"' //图片加载失败
			};
		},
		mounted() {
			this.shoplistapi();
		},
		watch: {
			'$route'(to, from) { //监听路由是否变化
				if (to.query.id != from.query.id || to.query.keyword != from.query.keyword) {
					this.id = to.query.id;
					this.keyword = to.query.keyword;
					this.shoplistapi(); //重新加载数据
				}
			}
		},
		methods: {
			// 二级分类
			sort(id) {
				if (this.id == id) {
					return false;
				}
				this.id = id;
				this.brand_id = '';
				this.keyword = '';
				this.$router.push({
					path: this.common.qycgrouter(this) + "/qycglist",
					query: {
						id: id
					}
				})
			},
			qyback(){
				this.$router.push({
					path: this.common.qycgrouter(this) + "/qycgindex",
				});
			},
			changetype(i){
				console.log(i,"123")
				this.shoplistapi(i)
			},
			shoplistapi(e) {
				this.$loading();
				this.datatype = false;
				let data = {
					shop_type: 'qycg',
					// access_token: this.$store.state.qycg_user.access_token,
					cat_id: this.id,
					page: this.list_page,
					limit:this.list_count,
					sort: this.filtrateIndex,
					sort_type: this.sort_type,
					end_price: this.end_price,
					start_price: this.start_price,
					keyword: this.keyword,
					is_rec:e
				};
				// console.log(data)
				this.$api.qycgList(data).then(res => {
					this.$loading().close();
					this.catlist = res.data.cat_list;
					//一级
					this.catlist1 = res.data.cat_list[0];
					//二级
					this.catlist2 = res.data.cat_list[1];
					//三级
					this.catlist3 = res.data.cat_list[2];
					this.ttshop_listshop = res.data.list;
					this.class_list_num = res.data.page_count;
					this.ttshop_znum = Number(res.data.row_count);
					this.datatype = true;
					// 商品轮播
					setTimeout(function() {
						for (let i = 0; i < res.data.list.length; i++) {
							let element = ".img-list" + i + " .img-listcon";
							let nextEl = ".img-list" + i + " .ttshop_next";
							let prevEl = ".img-list" + i + " .ttshop_prev";
							let mySwiper = new Swiper(element, {
								loop: false,
								slidesPerView: 5,
								spaceBetween: 5,
								observer: true,
								observeParents: true,
								navigation: {
									nextEl: nextEl,
									prevEl: prevEl,
								}
							});
						}
					}, 500)
				}).catch(err => {
					this.common.message(this, err);
				});
			},
			// 点击跳转详情
			listrouter(id) {
				let url = this.$router.resolve({
					path:this.common.qycgrouter(this) + '/qycgdetails',
					query: {
						id: id
					}
				})
				window.open(url.href);
			},
			ttshop_prev() {},
			ttshop_next() {},
			// 分类输入分页
			handleCurrentChangeList(e) {
				this.list_page = e;
				this.common.backTop();
				this.shoplistapi();
			},
			//分类上一页
			page_prevs(){
				if (this.currentPage1 > 1) {
					this.currentPage1--;
					this.common.backTop();
					this.shoplistapi();
				}
			},
			// 分类下一页
			page_nexts(){
				if (this.currentPage1 < this.class_list_num) {
					this.currentPage1++;
					this.common.backTop();
					this.shoplistapi();
				}
			},
			// 商品小图片移入事件
			enter(src, index) {
				if (src) {
					this.ttshop_listshop[index].pic_url = src;
				}
			},
			// 价格最大值最小值筛选
			confirms() {
				let samlls = Number(this.$refs.smallnum.value);
				let bigs = Number(this.$refs.bignum.value);
				if (samlls > bigs) {
					this.end_price = samlls;
					this.start_price = bigs;
					this.smallnum = bigs;
					this.bignum = samlls;
					
				} else {
					this.end_price = bigs;
					this.start_price = samlls;
					this.smallnum = samlls;
					this.bignum = bigs;
				}
				this.currentPage1 = 1;
				this.shoplistapi();
			},
			closenum() {
				this.smallnum = "";
				this.bignum = "";
				this.end_price = "";
				this.start_price = "";
				this.currentPage1 = 1;
				this.shoplistapi();
			},
			// // 确定
			// brandConfirm() {},
			// // 取消
			// brandCancel() {
			// 	this.more = true;
			// 	this.brandIndex = false;
			// },
			// // 鼠标移入事件
			// selectStyle(item) {
			// 	this.iShow = item;
			// 	this.isHidden = true;
			// },
			// // 鼠标移出事件
			// outStyle() {
			// 	this.iShow = -1;
			// 	this.isHidden = false;
			// },
			selectFiltrate(index) {
				if (this.filtrateIndex == index) {
					if (index == 2) {
						this.sort_type == 0 ? this.sort_type = 1 : this.sort_type = 0
					} else {
						return false;
					}
				}
				this.filtrateIndex = index;
				this.currentPage1 = 1;
				this.shoplistapi();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.content {
		padding-bottom: 40px;
		box-sizing: border-box;
		margin: 0 auto;
	}

	.goods-paging {
		margin: 40px 0;
	}

	.brand_active {
		height: 208px !important;
		overflow-y: scroll !important;
	}

	.rest_active {
		visibility: visible !important;
	}

	.rest_item_active {
		border-color: #ff0e25 !important;
		border-bottom-color: #fff !important;
		z-index: 3 !important;
	}

	.filtrate_active {
		border-bottom-color: #ff0e25 !important;
		color: #ff0e25 !important;
	}

	.Nav {
		border-bottom: 2px solid #ff0e25;
	}
//面包屑
.nav {
		height: 56px;
		border-bottom: 1px solid #ebebeb;

		.nav-item {
			color: #999999;

			a {
				color: #999;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				&:hover {
					color: #ff0e25;
				}
			}
		}

		.nav-img {
			height: 12px;
			width: 12px;
		}

		.nav-items {
			height: 24px;
			position: relative;
			overflow: hidden;
			background-color: #fff;
			transition: 0.3s;
			cursor: pointer;
			&:hover {
				overflow: visible;
				.nav-xia{
    				transform: rotateX(180deg);
				}
				dt {
					border-color: #ff0e25;
					border-bottom-color: #fff;
					z-index: 41;
					border-radius: 3px 3px 0 0;

					div {
						color: #ff0e25;
					}
				}

				dd {
					z-index: 40;
					border: 1px solid #ff0e25;
				}
			}

			dt {
				padding: 0px 4px 0px 8px;
				// line-height: 22px;
				height: 24px;
				border: 1px solid #ebebeb;
				position: relative;
				box-sizing: border-box;
				border-radius: 3px;
				background-color: #fff;
				z-index: 200;
			}

			.nav-xia {
				height: 12px;
				width: 12px;
				margin-left: 8px;
				&:hover{
					transform: rotateX(180deg)
				}
			}

			dd {
				width: 330px;
				padding: 6px 8px 10px 10px;
				position: absolute;
				top: 23px;
				left: 0;
				background-color: #fff;
				line-height: 24px;

				div {
					cursor: pointer;
    				transition: .5s;
    				-moz-transition: .5s;
    				-webkit-transition: .5s;
    				-o-transition: .5s;
    				width: 100px;
   	 				margin-right: 10px;
    				overflow: hidden;
    				white-space: nowrap;
    				text-overflow: ellipsis;
    				line-height: 30px;


					// width: 96px;
					// margin-right: 14px;
					// cursor: pointer;
					// transition: .5s;
					// -moz-transition: .5s;
					// -webkit-transition: .5s;
					// -o-transition: .5s;

					&:hover {
						color: #ff0e25;
					}
				}

				div:last-child {
					margin-right: 0;
				}
			}
		}

		.nav-option {
			padding: 0px 4px 0px 8px;
			height: 24px;
			border: 1px solid #ebebeb;
			box-sizing: border-box;
			border-radius: 3px;
			border: 1px solid #ebebeb;
			background-color: #fafafa;
			margin-right: 8px;

			span {
				color: #ff0e25;
			}

			.nav-del {
				height: 12px;
				width: 12px;
				margin-left: 8px;
				cursor: pointer;
			}
		}
	}
	// 商品列表
	.goods-box {
		width: 1080px;
		margin: 0 auto;
		margin-top: 18px;

		// 暂无商品
		.zanwugoods {
			width: 100%;
			padding: 150px 0;
			box-sizing: border-box;

			img {
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}

		.goods-rs {
			width: 1080px;

			.filtrate {
				width: 1080px;
				height: 40px;
				background: #fafafa;

				.filtrate-l-item {
					min-width: 64px;
					padding: 0 8px;
					box-sizing: border-box;
					// height: 40px;
					border-bottom: 2px solid transparent;
					color: #666666;
					cursor: pointer;

					.filtrate-l-img {
						height: 12px;
						width: 12px;
					}
				}

				.filtrate-pic {
					padding: 0 8px;
					position: relative;

					.filtrate-pics {
						height: 40px;
					}

					.filtrate-picbut {
						display: none;
						position: absolute;
						background: #fff;
						width: 100%;
						top: 39px;
						left: 0;
						padding: 8px;
						box-sizing: border-box;
						box-shadow: 0 15px 12px rgba(0, 0, 0, .1);
						z-index: 9999;
						span {
							float: left;
							font-size: 12px;
							color: #666;
							border: 1px solid #EBEBEB;
							border-radius: 2px;
							width: 56px;
							height: 24px;
							box-sizing: border-box;
							text-align: center;
							line-height: 20px;
							cursor: pointer;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;

							&:first-child {
								border-color: #FF3346;
								background: #FFF0F1;
								color: #FF0E25;
								margin-right: 8px;
							}

							&:last-child:hover {
								border-color: #FF3346;
								background: #FFF0F1;
								color: #FF0E25;
							}
						}
					}

					.filtrate-pic-input {
						width: 64px;
						height: 24px;
						background: #ffffff;
						border-radius: 2px;
						border: 1px solid #ebebeb;
						color: #999999;

						input {
							height: 24px;
							width: 50px;
						}
					}

					.line {
						width: 10px;
						height: 2px;
						background: #cccccc;
						margin: 0 4px;
					}

					&:hover {
						background: #fff;
						box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);
						border-radius: 2px;
					}

					&:hover .filtrate-picbut {
						display: block;
						border-radius: 0 0 2px 2px;
					}
				}

				.filtrate-r-item {
					height: 40px;
					padding: 0 10px;
					box-sizing: border-box;
					color: #666666;
					cursor: pointer;

					.filtrate-r-img {
						height: 12px;
						width: 12px;
						margin-right: 4px;
					}
				}

				.filtrate-r-all {
					margin-left: 40px;
					color: #666666;
					margin-right: 8px;
				}

				.filtrate-r-page {
					margin-right: 16px;

					.page-num {
						font-weight: bold;
						color: #666666;
						margin: 0 4px;

						span {
							font-weight: bold;
							color: #ff0e25;
						}
					}

					.page-img {
						height: 14px;
						width: 14px;
						cursor: pointer;
					}
				}
			}

			.list {
				width: 100%;
				cursor: pointer;
				display: flex;
				flex-wrap:wrap;

				// background-color: red;
				.item {
					width: 242px;
					// height: 458px;
					background-color: #fff;
					margin-right: 37px;
					margin-top: 20px;
					padding: 16px 12px;
					box-sizing: border-box;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
					position: relative;
					&:nth-child(4n) {
						margin-right: 0 !important;
					}

					&:hover {
						box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
					}

					.item-img {
						height: 218px;
						width: 218px;
					}
					.img-default-img{
          				width: 34px;
          				height: 34px;
          				position: absolute;
          				top: 15px;
          				right: 10px;
        			}
					.img-list {
						width: 100%;
						padding: 0 19px;
						box-sizing: border-box;
						margin-top: 8px;
						position: relative;

						.img-listcon {
							width: 100%;
							padding: 0 1px;
							box-sizing: border-box;

							.img-item {
								width: 32px !important;
								height: 32px;
								padding: 2px;
								border: 1px solid #ebebeb;
								box-sizing: border-box;
								margin-right: 5px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
								cursor: pointer;

								.img {
									width: 100%;
									height: 100%;
								}

								&:hover {
									border-color: #FF0E25;
								}

								&:last-child {
									margin-right: 0 !important;
								}
							}
						}

						.ttshop_prev {
							width: 14px;
							height: 14px;
							margin-top: -7px;
							background: url(../../../assets/images/ttshop_scleft.png) center no-repeat;
							left: 0;
							cursor: pointer;
							z-index: 100;
							outline: none;
						}

						.ttshop_next {
							width: 14px;
							height: 14px;
							margin-top: -7px;
							background: url(../../../assets/images/ttshop_scright.png) center no-repeat;
							right: 0;
							cursor: pointer;
							z-index: 100;
							outline: none;
						}
					}

					.pic {
						margin-left: 10px;
						font-weight: 500;
						color: #CC0000;
						font-size: 14px;
						// margin-top: 12px;
						// span{
						// 	margin-left: 10px;
						// 	font-weight: 500;
						// 	color: #CC0000;
						// 	font-size: 14px;
						// 	display: inline-block;
						// 	margin-right: 4px;
						// 	vertical-align: 1px;
						// }
					}

					.name {
						width: 218px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-top: 8px;
						color: #666666;
					}

					.evaluate {
						margin-top: 8px;
						color: #999999;

						span {
							color: #0e9cff;
							margin-right: 4px;
						}
					}

					.shop {
						margin-top: 8px;


						.shop-img {
							width: 20px;
							height: 20px;
							border-radius: 20px;
							margin-right: 4px;
						}

						span {
							color: #666666;
						}
					}

					.label {
						margin-top: 8px;

						span {
							min-width: 32px;
							padding: 0px 4px;
							border-radius: 3px;
							border: 1px solid #ff0e25;
							box-sizing: border-box;
							display: inline-block;
							color: #ff0e25;
							margin: 0 4px 4px 0;
						}
					}

					.operation {
						margin-top: 8px;
						height: 28px;
						border-top: 1px solid #ebebeb;
						border-bottom: 1px solid #ebebeb;
						padding: 0 8px;
						box-sizing: border-box;

						.line {
							width: 1px;
							height: 16px;
							background: #ebebeb;
						}

						.operation-item {
							color: #888888;

							.operation-img {
								width: 12px;
								height: 12px;
								margin-right: 4px;
								display: block;
							}
						}
					}
				}
			}
		}
	}
</style>